let printer_BillPrintActions = require("../../templates/printer/BillPrintActions.handlebars");
let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";
let DbRecorder = require("../../recorder/DbRecorder.js");
import PrintService from "../../service/PrintService.js";

let main = function () {
    return Backbone.View.extend({
        bill: null,
        table: null,
        events: {
            "click .btn.print, .printAction": "_print",
            "click div.receiptType": "_addReceiptType",
            "keyup": 'fastKeyCode'
        },
        initialize: function (options) {
            var self = this, el = options.el;
            if (!el) {
                el = $(printer_BillPrintActions(options.params || {}));
            }
            self.setElement(el);
            self.bill = options.bill;
            self.table = options.table;
            return self;
        },
        _print: function () {
            var self = this, bill = self.bill, table = self.table,
                result, types = [],
                editorExtensionId = DbRecorder.read("chromeAppId"),
                billDetail = DbRecorder.convert2JSON(bill), restaurant = POS.getRestaurant();
            var printerSetting = DbRecorder.read("networkPrinterSetting") || [];
            var bytes;
            _.each(self.$(".receipt-list .receiptType"), function (element) {
                if ($(element).hasClass('selected')) {
                    types.push($(element).data("type"));
                }
            });
            if (restaurant.get('fastFood')) {
                billDetail.fastfood = true;
            }
            billDetail.table = DbRecorder.convert2JSON(table);
            var posBytes = [];
            console.log("BillActions1",types);
            _.each(types, function (type) {
                DbRecorder.recordPrintQueue(self.bill, type);
                self.bill.recordRePrintCount(type);
                switch (type) {
                    case "Statement":
                        if (POS.checkFeature("MEMBERSHIP") && POS.checkFeature("WEIXIN_RESTAURANT") && POS.getRestaurant().get('printWeixinQrcode') && self.model.get('cashierView')) {
                            var discountStatus = bill.checkSingeDiscount();
                            var discount = bill.get('discount');
                            var discountItem = null;
                            var payments = _.filter(bill.get("payments").models, function (payment) {
                                return !payment.id
                            });
                            if (discountStatus) {
                                discountItem = JSON.stringify(_.map(bill.getBillItems().models, function (item) {
                                    return item.toJSON()
                                }))
                            }
                            var jxhr = $.post("/onlinePay/generateQrcode", {
                                billId: billDetail.id,
                                note: billDetail.note,
                                noFee: billDetail.noFee,
                                roundAmount: billDetail.roundAmount,
                                ignoreAmount: self.model.get("ignoreAmount"),
                                tipAmount: self.model.get("tipAmount"),
                                waiter: bill.get("waiter") ? JSON.stringify(bill.get("waiter")) : null,
                                restaurantId: restaurant.id,
                                membershipId: bill.membership ? bill.membership.id : 0,
                                discountId: discount ? discount.id : 0,
                                discountItem: discountItem,
                                dinerCount: billDetail.dinerCount,
                                taxId: billDetail.taxId
                            });
                            jxhr.done(function (response) {
                                if (response.success) {
                                    billDetail.qrcode = response.qrcodeUrl;
                                }
                            }).always(function () {
                                PrintService.printOrderReceipt(billDetail, null, "rePrint");
                            });
                        } else {
                            PrintService.printOrderReceipt(billDetail, null, "rePrint");
                        }
                        break;
                    case "Receipt":
                        PrintService.printCashierReceipt(billDetail, "rePrint");
                        break;
                    case "EachItem":
                        PrintService.printItemsReceipts(billDetail, null, null, "rePrint");
                        break;
                    case "RefundItem":
                        PrintService.printCancelledItemReceipts(billDetail, "rePrint");
                        break;
                    case "RefundAmount":
                        PrintService.printRefundedItemReceipts(billDetail, "rePrint");
                        break;
                    case "DisPatch":
                        PrintService.printRedispatchReceipt(billDetail, "rePrint");
                        // PrintService.openCashbox();
                        break;
                    case "TagItem":
                        PrintService.printTagReceipts(billDetail, null);
                        break;
                    default:
                        break;
                }
            });
        },
        _addReceiptType: function (evt) {
            var target = $(evt.currentTarget);
            if (target.hasClass('selected')) {
                target.removeClass('selected');
            } else {
                target.addClass("selected");
            }
        }
    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/printer/BillPrintActionsView.js